<div class="row">
  <div class="col-sm-12">
    <app-card [title]="'global.overview'|translate">
      <app-grid [grid]="grid"></app-grid>
      <button class="btn btn-primary ripple light pull-right my-3" routerLink="/back-office/option/overview"
         type="button">{{'admin.option.view_options'|translate}}</button>
    </app-card>
  </div>
</div>

<app-modal-basic #readdModel>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_readd_title' | translate:{entity: 'Option'} }}</h4>
    <button type="button" class="close basic-close" (click)="readdModel.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_readd_body' | translate}}: <span [innerHTML]="optionName"></span> ?</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-default ripple me-4" (click)="readdModel.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light" (click)="readd()">{{'global.actions.readd'|translate}}</button>
  </div>
</app-modal-basic>

<ng-template #modelTooltip let-row="row" let-value="value" let-column="column">
       <span class="tooltip-item" *ngIf="calcModel(row)">
                         <span class="tooltipBox">
                          {{dataArray.length}}
                         </span>
                        <span class="desc-place" *ngIf="dataArray.length>0">
                        <ng-container *ngFor="let item of dataArray; let i = index;">
                          <span>
                           {{item.model.name}}{{(i !== (dataArray.length - 1)) ? ',' : ''}}
                          </span>
                        </ng-container>
                    </span>
       </span>

</ng-template>
